export var CUI_Theme = 'cuiTheme';